import { useBookingContext } from '../BookingContext'
import { Card, CardContent } from '@w/components/ui/card'
import { Badge } from '@w/components/ui/badge'
import { Clock, DollarSign, Sparkles } from 'lucide-react'

export default function ServiceSelection() {
  const { services, selectService } = useBookingContext()

  return (
    <Card className="border-none shadow-none">
      <CardContent className="p-6">
        <div className="mb-6">
          <h3 className="font-semibold text-xl mb-1 flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-primary" />
            Choose a Service
          </h3>
          <p className="text-sm text-muted-foreground">Select the service you'd like to book</p>
        </div>

        <div className="space-y-3 max-h-[450px] overflow-y-auto pr-1">
          {services.map((service) => {
            // Format duration
            const hours = Math.floor(service.base_duration / 60)
            const minutes = service.base_duration % 60
            const durationText = `${hours}h${minutes > 0 ? ` ${minutes}m` : ''}`

            // Format price
            let priceText = ''
            if (service.price_range?.minimum) {
              priceText = service.price_range.minimum
            }

            return (
              <Card
                key={service.id}
                className="cursor-pointer transition-all duration-200 hover:shadow-lg hover:border-primary/50 hover:scale-[1.02] group"
                onClick={() => selectService(service)}
              >
                <CardContent className="p-5 flex gap-4">
                  {/* Icon */}
                  <div
                    className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-110"
                    style={{
                      backgroundColor: service.color_code
                        ? `${service.color_code}15`
                        : 'rgba(59, 130, 246, 0.1)',
                    }}
                  >
                    <svg
                      className="w-7 h-7"
                      style={{ color: service.color_code || '#3b82f6' }}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                      />
                    </svg>
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <h4 className="font-semibold text-lg mb-2 text-foreground group-hover:text-primary transition-colors">
                      {service.name}
                    </h4>
                    {service.description && (
                      <p className="text-sm text-muted-foreground mb-3 line-clamp-2 leading-relaxed">
                        {service.description}
                      </p>
                    )}
                    <div className="flex gap-3 flex-wrap">
                      <Badge variant="secondary" className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        {durationText}
                      </Badge>
                      {priceText && (
                        <Badge variant="outline" className="flex items-center gap-1 text-green-600 border-green-200">
                          <DollarSign className="w-3 h-3" />
                          From ${priceText}
                        </Badge>
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>
            )
          })}
        </div>
      </CardContent>
    </Card>
  )
}
